/**
 * Validación local de una tarjeta nueva, antes de llamar al SDK. Criterios del manual de Payway
 * (número ≥ 15 dígitos, vencimiento no pasado, titular con al menos una letra) más los que exige
 * el negocio (CVV y DNI obligatorios).
 */
import type { NewCardField } from '../domain/errors';
import type { NewCardData } from '../domain/models';

const digitsOnly = (value: string): string => value.replace(/\D/g, '');

const isExpired = (month: number, twoDigitYear: number, now: Date): boolean =>
  (2000 + twoDigitYear) * 12 + month < now.getFullYear() * 12 + (now.getMonth() + 1);

export const validateNewCard = (data: NewCardData, now: Date = new Date()): NewCardField[] => {
  const invalid: NewCardField[] = [];

  const number = digitsOnly(data.cardNumber);
  if (number.length < 15 || number.length > 19) {
    invalid.push('cardNumber');
  }

  const month = Number(data.expirationMonth);
  const year = Number(data.expirationYear);
  const hasExpiration = /^\d{2}$/.test(data.expirationMonth) && /^\d{2}$/.test(data.expirationYear);
  if (!hasExpiration || month < 1 || month > 12 || isExpired(month, year, now)) {
    invalid.push('expiration');
  }

  if (!/\p{L}/u.test(data.holderName)) {
    invalid.push('holderName');
  }

  if (!/^\d{3,4}$/.test(data.securityCode)) {
    invalid.push('securityCode');
  }

  if (!/^\d{6,10}$/.test(digitsOnly(data.documentNumber))) {
    invalid.push('document');
  }

  return invalid;
};
